/* eslint-disable max-len */
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getFormFields, getFieldDependents } from '../utils/equipmentStatusListUtils';
import {
  clearEquipmentStatusFilterV3,
  setCurrentEquipmentStatusFilterItemV3,
} from '~/store/dispatch/actions';
import { saveFilters } from '~/services/cache';

export const useEquipmentStatusFilters = (filterOptions) => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();


  const currentFilter = useSelector(
    state => state.dispatch.currentEquipmentStatusFilterV3,
    shallowEqual,
  );

  const formFieldsFilter = useMemo(() => (filterOptions ? getFormFields(filterOptions, translate) : []), [filterOptions]);

  useEffect(() => {
    if (Object.keys(currentFilter).length > 0) {
      saveFilters('EquipmentStatus', currentFilter, 'user');
    }
  }, [currentFilter]);

  const cleanDependents = useCallback(
    (key) => {
      if (key === 'equip_type') {
        const dependents = getFieldDependents(formFieldsFilter);
        dependents.forEach((dependentKey) => {
          if (dependentKey === key) {
            dispatch(setCurrentEquipmentStatusFilterItemV3(dependentKey, []));
          }
        });
      }
    },
    [dispatch, formFieldsFilter],
  );

  const handleSetMultipleFilter = useCallback(
    ({ value, key }) => {
      cleanDependents(key);
      const newValue = value ? value.map(item => item?.value) : [];
      dispatch(setCurrentEquipmentStatusFilterItemV3(key, newValue));
    },
    [dispatch],
  );

  const handleCleanFilterInternal = useCallback(() => {
    dispatch(clearEquipmentStatusFilterV3());
  }, [dispatch]);

  const handleFilterChange = useCallback(
    ({ key, value }) => {
      cleanDependents(key);

      dispatch(setCurrentEquipmentStatusFilterItemV3(key, value));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      currentFilter,
      formFieldsFilter,
      handleFilterChange,
      handleFilterChangeMultiple: handleSetMultipleFilter,
      handleClean: handleCleanFilterInternal,
    }),
    [
      currentFilter,
      formFieldsFilter,
      handleFilterChange,
      handleSetMultipleFilter,
      handleCleanFilterInternal,
    ],
  );
};
